import React from "react";
import { FormGroup, InputGroup, Intent, TextArea, Button } from "@blueprintjs/core";
import { Trans } from "react-i18next";
import i18next from "i18next";

// Render translated key
export function renderTK(i18nKey: string) {
	return <Trans i18nKey={i18nKey} />
}

// Return translated key as string
export function translateKey(i18nKey: string) {
	return i18next.t(i18nKey);
}

export function renderNormalButtonTranslated(rightIcon: any, onClick: any, intent: any, text_slug: string) {
	const buttonLabel = <Trans i18nKey={text_slug}></Trans>

	return <Button style={{width: '50%', marginTop: '20px'}} rightIcon={rightIcon} onClick={() => { onClick(); }} intent={intent} text={buttonLabel} />
}

export function buildInputTranslated(value: string, icon:string|undefined, i18nKey: string, id: string, type: string, ref: any, onChange?: () => void, autoFocus?: boolean, onKeyPress?: any) {
	let typeBasedIcon:any = icon;

	if (type === "email") {
		typeBasedIcon = "envelope";
	}

	if (type === "password") {
		typeBasedIcon = "key";
	}

	return <FormGroup
		inline={false}
		intent={Intent.NONE}
		label={translateKey(i18nKey)}
		labelFor={id}
	>
		<InputGroup autoFocus={autoFocus} leftIcon={typeBasedIcon} onChange={onChange} defaultValue={value} inputRef={ref} type={type} id={id} placeholder="" onKeyPress={onKeyPress} disabled={false} intent={Intent.NONE} />
	</FormGroup>
}

export function buildInput(value: string, icon:string|undefined, label: string, id: string, type: string, ref: any, onChange?: () => void, autoFocus?: boolean, onKeyPress?: any) {
	let typeBasedIcon:any = icon;

	if (type === "email") {
		typeBasedIcon = "envelope";
	}

	if (type === "password") {
		typeBasedIcon = "key";
	}

	return <FormGroup
		inline={false}
		intent={Intent.NONE}
		label={label}
		labelFor={id}
	>
		<InputGroup autoFocus={autoFocus} leftIcon={typeBasedIcon} onChange={onChange} defaultValue={value} inputRef={ref} type={type} id={id} placeholder="" onKeyPress={onKeyPress} disabled={false} intent={Intent.NONE} />
	</FormGroup>
}

export function buildInputLage(value: string, label: string, id: string, type: string, ref: any, onChange?: () => void) {
	return <FormGroup
		inline={false}
		intent={Intent.NONE}
		label={label}
		labelFor={id}
	>
		<TextArea
			growVertically={true}
			large={true}
			style={{width: '100%'}}
			onChange={onChange} 
			defaultValue={value} 
			inputRef={ref}
			id={id}
		/>
	</FormGroup>
}
